export const ENVIRONMENTS = [ 'prod', 'dev', 'staging', 'test' ] as const;
export type Environment = (typeof ENVIRONMENTS)[number];

const ENVIRONMENT_MAPPING: Record<string, Environment> = {
  production: 'prod',
  prod: 'prod',
  development: 'dev',
  dev: 'dev',
  staging: 'staging',
  test: 'test',
};

export const APP_ID = process.env.APP_ID as string;
export const APP_ENV: Environment = process.env.APP_ENV ? ENVIRONMENT_MAPPING[process.env.APP_ENV] : 'dev';
export const APP_VERSION = process.env.APP_VERSION;

export const API_URL = process.env.API_URL;

export const AUTH_AUTHORITY = `${process.env.OAUTH_PROVIDER_BASE_URL}/realms/${process.env.OAUTH_REALM}`;
